import React, { type FC } from 'react';
import {
  Root as SelectRoot,
  type SelectProps as BaseSelectProps,
  Value as SelectValue
} from '@radix-ui/react-select';
import { type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib';
import { textInputCva } from '../TextInput';
import { SelectContent, SelectTrigger, SelectItem } from './components';

type SelectProps = Omit<
  BaseSelectProps,
  'onValueChange' | 'defaultValue' | 'children' | 'value'
> & {
  className?: string;
  value: string | undefined;
  placeholder?: string;
  id?: string;
  options: { value: string; label: string; disabled?: boolean }[];
  onChange: (value: string) => void;
} & VariantProps<typeof textInputCva> & {
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  };

export const Select: FC<SelectProps> = (props) => {
  const {
    variant = 'fill',
    size = 'md',
    value,
    id,
    placeholder,
    options = [],
    className,
    onChange,
    hasError = false,
    ...rest
  } = props;

  return (
    <SelectRoot value={value} onValueChange={onChange} {...rest}>
      <SelectTrigger
        className={cn(
          textInputCva({ variant, size, hasError, hasValue: Boolean(value) }),
          className
        )}
        id={id}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>

      <SelectContent sideOffset={12}>
        {options.map(({ value, label, disabled }) => (
          <SelectItem key={value} disabled={disabled} value={value}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  );
};
